export default function() {
  return (array = []) => {
    const hourObj = {};
    array.filter(({ repeat }) => !repeat).forEach(session => {
      session.fieldOfStudy.forEach(({ name, credits }) => {
        if (!hourObj[name]) hourObj[name] = 0;
        hourObj[name] += Number(credits);
      });
    });
    return hourObj;
  };
}



// WEBPACK FOOTER //
// ./src/app/filters/CnfTotalHours.js